<template>
  <v-container fluid>
    <h1 class="text-center my-5">{{ $t('title') }}</h1>
    <v-row v-blur="blurConfig" align="center" justify="center">
      <p class="mr-3 mt-n1">{{ $t('subtitlePrepend') }} </p>
      <v-select :label="$t('label')" style="max-width: 21%;" :items="this.$store.state.user.brokerAccounts" item-value="id" v-model="brokerAccountSelected" @change="accountChanged" dense outlined>
        <template v-slot:selection="data">
          {{ (data.item.broker.name !== 'All')? ((data.item.identifier !== '')? data.item.identifier : data.item.broker.name): 'All' }}
          <v-icon v-if="data.item.verified" color="blue" class="ml-2" small>fa-check-circle</v-icon>
        </template>
        <template v-slot:item="data">
          {{ (data.item.identifier !== '')? `${data.item.broker.name} · ${data.item.identifier}` :  data.item.broker.name }}
          <v-icon v-if="data.item.verified" color="blue" class="ml-2" small>fa-check-circle</v-icon>
        </template>
      </v-select>
      <p class="ml-3 mt-n1">{{ $t('subtitleAppend') }}</p>
    </v-row>
    <TradingPlan v-blur="blurConfig" :account-id="this.brokerAccountSelected"/>
    <LargeCardAd v-if="ad !== null" :ad="ad"/>

    <!-- Overlay for CTA upgrade to pro !-->
    <v-overlay v-model="canSeePlan" absolute opacity="0">
      <UpgradeToPro :message="messageUpgradeToPro" @closeWindow="seeProAdvantages = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import AdEngine from '../../ads/adEngine';

import TradingPlan from "@/views/Plan/components/TradingPlan";
import UpgradeToPro from "@/components/UpgradeToPro";
import LargeCardAd from "@/ads/LargeCardAd";
export default {
  name: "PlanIndex",
  components: {LargeCardAd, UpgradeToPro, TradingPlan},
  data() {
    return {
      // Ads
      ad: null,

      blurConfig: {
        isBlurred: !this.$store.state.user.isPro,
        opacity: 0.1,
        filter: "blur(1.2px)",
        transition: "all .3s linear"
      },
      canSeePlan: !this.$store.state.user.isPro,
      messageUpgradeToPro: this.$t('ctaUpgradeToPro'),

      brokerAccounts: [],
      brokerAccountSelected: 0,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    retrieveAd() {
      this.ad = AdEngine.getRandomAd('Large Ad');
    },
    init() {
      this.retrieveAd();
      this.brokerAccounts = this.$store.state.user.brokerAccounts;
      this.brokerAccountSelected = this.brokerAccounts[0].id;
    },
  },
}
</script>

<i18n>
{
  "en": {
    "title": "Trading Plan",
    "subtitlePrepend": "Trading Plan for",
    "label": "Broker Account",
    "subtitleAppend": "account",
    "ctaUpgradeToPro": "With pro you can create unlimited trading plan."
  },
  "es": {
    "title": "Plan de Trading",
    "subtitlePrepend": "Plan de Trading para",
    "label": "Cuenta de Broker",
    "subtitleAppend": "cuenta",
    "ctaUpgradeToPro": "Con pro podrás crear ilimitados planes de trading."
  }
}
</i18n>

<style scoped>

</style>
